/* global angular */

export default [
  '$animate',
  'uiStateManagerService',
  'uiStateManagerHistoryService',
  directive,
]

const UI_UNLOCK_ELEMENT = 'ui-state-manager-unlock-element'
const UI_UNLOCK_ELEMENT_PROGRESS = 'ui-state-manager-unlock-element-progress'
const UI_LOCK_ELEMENT = 'ui-state-manager-lock-element'
const UI_LOCK_ELEMENT_PROGRESS = 'ui-state-manager-lock-element-progress'

function directive(
  $animate,
  uiStateManagerService,
  uiStateManagerHistoryService
) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function lockerDirectiveLink(scope, element, attr) {
      const toBeDestroyed = []
      /*
       * When active, unlock.
       * When disabled, lock.
       */
      let uiLock = attr.uiStateManagerLockState || 'active'
      let uiUnlock = attr.uiStateManagerUnLockState || 'disabled'
      // Little syntactic sugar to make the API taste better.
      let uiReversed = attr.uiStateManagerReversed || false
      if (angular.isString(uiReversed)) {
        uiReversed = scope.$eval(uiReversed)
      }
      // If reversed, lets start unlocked.
      if (uiReversed) {
        uiLock = attr.uiStateManagerLockState || 'disabled'
        uiUnlock = attr.uiStateManagerUnLockState || 'active'
        element.addClass(UI_LOCK_ELEMENT)
        scope.currentViewState = 'active'
      } else {
        element.addClass(UI_UNLOCK_ELEMENT)
        scope.currentViewState = 'disabled'
      }
      scope.$on('$destroy', function() {
        for (let idx = 0; idx < toBeDestroyed.length; idx++) {
          toBeDestroyed[idx]()
        }
      })
      const onStateChangeWatch = function onStateChangeWatch(payload) {
        $animate[payload['state'] === uiLock ? 'addClass' : 'removeClass'](
          element,
          UI_LOCK_ELEMENT,
          {
            tempClasses: UI_LOCK_ELEMENT_PROGRESS,
          }
        ).then(function lockAnimationCallback() {
          scope.currentViewState = 'disabled'
        })
        $animate[payload['state'] === uiUnlock ? 'addClass' : 'removeClass'](
          element,
          UI_UNLOCK_ELEMENT,
          {
            tempClasses: UI_UNLOCK_ELEMENT_PROGRESS,
          }
        ).then(function unlockAnimationCallback() {
          scope.currentViewState = 'active'
        })
      }
      toBeDestroyed.push(
        uiStateManagerService.onStateChange(
          attr.uiStateManagerLocker,
          onStateChangeWatch
        )
      )
      uiStateManagerHistoryService.replayHistory(
        attr.uiStateManagerLocker,
        onStateChangeWatch
      )
    },
  }
}
